module.exports = __webpack_public_path__ + "static/media/directcc_1003.a23ee506.ico";